module.exports = __webpack_public_path__ + "img/background.348fff34.png";